import React from 'react'
import PropTypes from 'prop-types'
import InfiniteScroll from 'react-infinite-scroll-component'
import CategoryProductList from 'pages/category/list'
import { getIsBodyFreezed } from 'lib/utils/common/commonUtils'
import { PRODUCT_LIST_LAYOUT_VIEW } from 'components/visibility/duck'

const SearchProducts = ({
  hasMore,
  isFetchingProducts,
  isPhone,
  loadMoreProducts,
  products,
  query,
  view,
}) => {
  const disableLoadMore = !hasMore || getIsBodyFreezed() || isFetchingProducts

  return (
    <InfiniteScroll
      next={loadMoreProducts}
      dataLength={products.length}
      scrollThreshold={0.7}
      hasChildren={products.length > 0}
      hasMore={!disableLoadMore}
    >
      <CategoryProductList
        displayQuickAddToBag={
          view === PRODUCT_LIST_LAYOUT_VIEW.BLOCK_VIEW ?? false
        }
        displayHoverInteractions
        isSearchPage
        isPhone={isPhone}
        list={products}
        refId={query}
        refType="search"
      />
    </InfiniteScroll>
  )
}

SearchProducts.defaultProps = {
  isFetchingProducts: false,
  products: null,
  query: '',
  view: null,
}

SearchProducts.propTypes = {
  hasMore: PropTypes.bool.isRequired,
  isFetchingProducts: PropTypes.bool,
  isPhone: PropTypes.bool.isRequired,
  loadMoreProducts: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})),
  query: PropTypes.string,
  view: PropTypes.string,
}

export default SearchProducts
